<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="test-package-group-server-table"
      class="w-100"
    >
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/testpackagegroups/${row.id}`" class="btn-link">
          {{ row.name }}
        </a>
      </span>
      <span slot="sample_type.name" slot-scope="{ row }">
        <existence-gate :entity="row" :levels="['sample_type']" :field="'name'">
          <template #existing-content>
            <router-link
              :to="`/sampletypes/${getData(row, {
                levels: ['sample_type'],
                field: 'id',
              })}`"
            >
              {{ getData(row, { levels: ["sample_type"], field: "name" }) }}
            </router-link>
          </template>
        </existence-gate>
      </span>
      <span slot="test_packages" slot-scope="{ row }">
        {{ `${row.test_packages.length} item(s)` }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit test package group')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/testpackagegroups/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete test package group')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import TestPackageGroupCollection from "@/collections/lab/TestPackageGroupCollection";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getEntityData } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "TestPackageGroupServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ModalTrashBasket,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new TestPackageGroupCollection(),
    },
    show_columns: {
      type: Array,
      default: () => [
        "name",
        "sample_type.name",
        "test_packages",
        "description",
        "actions",
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["name", "sample_type.name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit test package group") ||
      this.checkPermission("delete test package group");

    return {
      entity_type: "testPackageGroup",
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          headings: {
            "sample_type.name": "Type",
            test_packages: "Test Package Size",
          },
          texts: {
            leadingError: "Oops! Server error =(",
          },
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "testPackageGroupTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete test package group") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
  },
};
</script>
